export var defaultProps = {
  open: false,
  animated: true,
  delay: 200
};